import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../../engineering-systems-constants';
import { HeaderSectionStructure } from '../../../components/header-section/header-section-types';

export const VENTILATION_HEADER_SECTION_CONFIG: HeaderSectionStructure = {
  title: 'Системы вентиляции',
  description:
    'Спроектируем и\u00A0установим систему вентиляции любой сложности под ключ. Выполняем работы от\u00A0установки бытовых вентиляторов до\u00A0обеспечения полноценного воздухообмена в\u00A0доме с\u00A0использованием приточно-вытяжной установки. Оформите заявку, а\u00A0мы\u00A0подберём решение, составим проект и\u00A0установим оборудование у\u00A0вас дома.',
  img: {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/systems/ventilation-2.jpg/ventilation-2.jpg`,
    alt: 'Системы вентиляции',
  },
  consultationSignupBtn: {
    elementBlock: 'landingSistemyVentilyacii',
    label: 'Записаться на консультацию',
    elementText: 'Системы вентиляции',
  },
};
